import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';


const WapiLogin = () => {
  const [status, setStatus] = useState('Checking...');
  const [qrCode, setQrCode] = useState(null);

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [areas, setAreas] = useState([]);
  const [memberId, setMemberId] = useState('');
  const [groupId, setGroupId] = useState('');

  const host_url = localStorage.getItem('host_url');
  const store = localStorage.getItem('store');

  const checkLoginStatus = async () => {
    try {
      const res = await fetch(`${host_url}/whatsapp/status`);
      const data = await res.json();
      if (data.loggedIn) {
        setStatus('✅ WhatsApp is logged in');
        setQrCode(null);
      } else {
        setStatus('🔒 Not logged in');
      }
    } catch (err) {
      setStatus('❌ Error checking status');
    }
  };

  const startClient = async () => {
    setStatus('Starting WhatsApp client...');
    setQrCode(null);

    try {
      await fetch(`${host_url}/whatsapp/start`, { method: 'POST' });
      setTimeout(fetchQR, 1000);
    } catch (err) {
      setStatus('❌ Error starting client');
    }
  };

  const fetchQR = async () => {
    try {
      const res = await fetch(`${host_url}/whatsapp/qr`);
      if (res.ok) {
        const data = await res.json();
        console.log("QR Length:", data.qr.length);
        console.log("QR Start:", data.qr.substring(0, 40));
        setQrCode(data.qr);
        setStatus('📲 Scan the QR code below');
      } else {
        setQrCode(null);
        setStatus('❌ QR not available');
      }
    } catch (err) {
      setStatus('❌ Error fetching QR');
    }
  };

  const logout = async () => {
    try {
      await fetch(`${host_url}/whatsapp/logout`, { method: 'POST' });
      setStatus('👋 Logged out');
      setQrCode(null);
    } catch (err) {
      setStatus('❌ Logout failed');
    }
  };

  const addMember = async () => {
    console.log('memberId :', memberId);
    console.log('GroupId :', groupId);
    {/*
        try {
          await fetch(`${host_url}/whatsapp/add-member`, { 
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ memberId, groupId }), 
                });
          alert('👋 Number add in group');
        } catch (err) {
          setStatus('❌ Nuber add failed');
        }
    */}
  };

  const handleBack = () => {
    navigate('../dashboard');
  };

  useEffect(() => {
      document.title = "WahtsApp";
    }, []); // for Title Set

  // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
            handleBack();
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, []);

  useEffect(() => {
    checkLoginStatus();
  }, []);

  const handleModal = async () => { 

      try {
        const response = await fetch(`${host_url}/wg_list`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'list',
            store: store,
            areaId : '',
            areaName: '',
            areaEName: '',
          }),
        });
        const data = await response.json();
        setAreas(data);
        console.log(data);
        setModalVisible(true);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }    
  }; 

  // Styles
  const containerStyle = {
    maxWidth: 400,
    margin: '40px auto',
    padding: 20,
    borderRadius: 8,
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    backgroundColor: '#fff',
    textAlign: 'center',
  };

  const statusStyle = {
    marginBottom: 20,
    fontWeight: '600',
    fontSize: 16,
  };

  const baseButton = {
    color: '#fff',
    border: 'none',
    padding: '10px 18px',
    fontSize: 16,
    borderRadius: 6,
    cursor: 'pointer',
    margin: '8px',
    minWidth: 130,
    transition: 'background-color 0.3s',
  };

  const buttonVariants = {
    primary: {
      backgroundColor: '#007bff',
      hover: '#0056b3',
    },
    success: {
      backgroundColor: '#28a745',
      hover: '#1e7e34',
    },
    danger: {
      backgroundColor: '#dc3545',
      hover: '#a71d2a',
    },
    warning: {
      backgroundColor: '##157fa3',
      hover: '##157fa3',
    },
  };

  // Hover states
  const [hovered, setHovered] = useState(null);

  const getButtonStyle = (variant) => ({
    ...baseButton,
    backgroundColor: buttonVariants[variant].backgroundColor,
    ...(hovered === variant ? { backgroundColor: buttonVariants[variant].hover } : {}),
  });

  const qrStyle = {
    margin: '0 auto 10px',
    width: 250,
    height: 250,
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    borderRadius: 8,
  };

  return (
    <div style={containerStyle}>
      <h2>WhatsApp Web Login</h2>
      <p style={statusStyle}>Status: {status}</p>

      {!qrCode && status !== '✅ WhatsApp is logged in' && (
        <button
          style={getButtonStyle('success')}
          onMouseEnter={() => setHovered('success')}
          onMouseLeave={() => setHovered(null)}
          onClick={startClient}
        >
          Start WhatsApp
        </button>
      )}

      {qrCode && (
        <div>
          <img
            src={qrCode}
            alt="WhatsApp QR Code"
            style={qrStyle}
            onLoad={() => console.log("QR Loaded")}
            onError={(e) => {
              console.log("QR Error");
              console.log(e);
            }}
          />
          <p>Scan this QR code with your WhatsApp</p>
        </div>
      )}

      <div>
        
        {status === '✅ WhatsApp is logged in' && (
          <button
            style={getButtonStyle('danger')}
            onMouseEnter={() => setHovered('danger')}
            onMouseLeave={() => setHovered(null)}
            onClick={logout}
          >
            🚪 Logout
          </button>
        )}

        <button
          style={getButtonStyle('primary')}
          onMouseEnter={() => setHovered('primary')}
          onMouseLeave={() => setHovered(null)}
          onClick={checkLoginStatus}
          title="Check WhatsApp Login Status"
        >
          🔄 Check Status
        </button>
      </div>



     {/* Modal for Add Member in Group */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Add number in Group</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left">Number</td>
                          <td><input type="text" value={memberId} onChange={(e) => setMemberId(e.target.value)} /></td>
                        </tr>
                        <tr>
                          <td className="cell-left">Area</td>
                          <td>
                            <select value={groupId} onChange={(e) => setGroupId(e.target.value)}>
                              <option value="">Select Area</option>
                              {areas.map((area) => (
                                <option key={area.groupId} value={area.groupId}>
                                  {area.areaEName}
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={addMember}>
                      Add
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>
    </div>
  );
};

export default WapiLogin;
